export default function AboutSection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300 bg-secondary-50 text-secondary-700 text-xs font-medium mb-6">
              Cos'è Itaobuy Spreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-8">
              Cos'è Itaobuy Spreadsheet e perché è così{' '}
              <span className="text-primary-500 italic">utilizzato?</span>
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
              Itaobuy Spreadsheet è uno strumento organizzativo che permette agli utenti di trovare, classificare e analizzare prodotti attraverso liste strutturate. Centralizza tutte le informazioni in un unico documento, rendendo la ricerca estremamente più efficiente.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20organized%20fashion%20product%20display%20on%20warm%20wooden%20shelf%20in%20bright%20Italian%20room%20natural%20sunlight%20through%20window%20curated%20clothing%20items%20and%20accessories%20neatly%20arranged%20cream%20walls%20terracotta%20accents%20clean%20minimalist%20aesthetic%20professional%20editorial%20style&width=800&height=600&seq=about-img-organize-01&orientation=landscape"
                alt="Organizzazione prodotti Itaobuy Spreadsheet"
                title="Itaobuy Spreadsheet - Organizzazione Prodotti"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="font-heading text-2xl font-semibold text-foreground-900 mb-4">Organizzazione Centralizzata</h3>
              <p className="text-foreground-600 text-base leading-relaxed mb-4">
                Invece di saltare da un sito all'altro, da una scheda all'altra del browser, Itaobuy Spreadsheet ti offre un unico punto di accesso dove tutte le informazioni sono organizzate in modo chiaro e coerente. Questo ti fa risparmiare ore di ricerca.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Tutti i prodotti in un unico documento strutturato</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Categorie multiple e ben definite per ogni esigenza</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Aggiornamenti regolari con nuovi prodotti</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1">
              <h3 className="font-heading text-2xl font-semibold text-foreground-900 mb-4">Risparmio di Tempo Garantito</h3>
              <p className="text-foreground-600 text-base leading-relaxed mb-4">
                Il tempo è la risorsa più preziosa, e Itaobuy Spreadsheet è progettato proprio per ottimizzarlo. Invece di passare ore a cercare manualmente prodotti simili e confrontarli, puoi avere una panoramica completa in pochi minuti.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Confronto immediato tra prodotti simili</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Analisi rapida grazie alla struttura tabellare</span>
                </li>
                <li className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  <span>Accesso diretto ai prodotti con un solo click</span>
                </li>
              </ul>
            </div>
            <div className="rounded-2xl overflow-hidden aspect-[4/3] order-1 lg:order-2">
              <img
                src="https://readdy.ai/api/search-image?query=Efficient%20modern%20workspace%20with%20laptop%20showing%20organized%20product%20list%20on%20screen%20next%20to%20ceramic%20coffee%20cup%20warm%20natural%20morning%20light%20cream%20walls%20and%20sage%20green%20plant%20Italian%20minimalist%20interior%20design%20clean%20focused%20productivity%20scene%20editorial%20photography&width=800&height=600&seq=about-img-time-02&orientation=landscape"
                alt="Risparmio tempo Itaobuy Spreadsheet"
                title="Itaobuy Spreadsheet - Risparmio di Tempo"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="mt-16 max-w-3xl mx-auto">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Caratteristica</th>
                    <th className="py-4 px-4 md:px-6 text-sm font-semibold text-foreground-800">Metodo Tradizionale</th>
                    <th className="py-4 px-4 md:px-6 text-sm font-semibold text-primary-600">Itaobuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-700 font-medium">Ricerca prodotti</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-500">Manuale e dispersiva</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-primary-600 font-medium">Organizzata e strutturata</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-700 font-medium">Categorie</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-500">Limitate e frammentate</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-primary-600 font-medium">Multiple e complete</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-700 font-medium">Analisi informazioni</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-500">Difficile e lunga</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-primary-600 font-medium">Semplificata e rapida</td>
                  </tr>
                  <tr>
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-700 font-medium">Risparmio tempo</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-foreground-500">Basso</td>
                    <td className="py-4 px-4 md:px-6 text-sm text-primary-600 font-medium">Molto alto</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}